import React from 'react';

export type WithConditionParams = {
  hook: () => void;
  disabled: boolean;
};

export const withCondition = ({ hook, disabled }: WithConditionParams) => {
  if (disabled) return () => <></>;
  return () => {
    hook();
    return <></>;
  };
};
